export default "__VITE_ASSET__BNKJmtEv__"